const administracionDeMenus = {
    ObtenerMenusPW: 'SICPO/AdministracionDeMenusPW/ObtenerMenus',
    AgregarNuevoMenuPW: 'SICPO/AdministracionDeMenusPW/AgregarNuevoMenu',
    ModificarMenuPW: 'SICPO/AdministracionDeMenusPW/ModificarMenu',
    CambiarEstatusDeMenusPW: 'SICPO/AdministracionDeMenusPW/CambiarEstatusDeMenus',
    ModificarOrdenamientoDeMenusPW: 'SICPO/AdministracionDeMenusPW/ModificarOrdenamientoDeMenus',
    OrdenarAlfabeticamenteMenusPW: 'SICPO/AdministracionDeMenusPW/OrdenarAlfabeticamenteMenus'
}

export default administracionDeMenus;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICPO/sistema/paginaweb/administracionDeMenus/administracionDeMenus.js
// module id = null
// module chunks = 